import Vue from 'vue'
import VueGtag from 'vue-gtag'
import VueExpandableImage from 'vue-expandable-image'
import { Chart as ChartJS, registerables } from 'chart.js'
import { install } from 'resize-observer'
import '@mdi/font/css/materialdesignicons.css'

import App from '@/App'
import store from '@/store'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import Ads from 'vue-google-adsense'

/** CSS */
import 'vuetify/dist/vuetify.min.css'
import './assets/css/nprogress.css'
Vue.config.errorHandler = function (err, vm, info) {
	console.error(`Error: ${err.toString()}\nInfo: ${info}`)
}
// if dont support resize observer then install it
if (!window.ResizeObserver) install()

ChartJS.register(...registerables)
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)

Vue.config.productionTip = false
Vue.prototype.$api = process.env.VUE_APP_API_URL
Vue.prototype.$api_base = process.env.VUE_APP_API_URL_BASE
Vue.prototype.$secretKey = '@rk !nf0soft K*y'

console.log(Vue.prototype)

Vue.use(VueExpandableImage)
Vue.use(
	VueGtag,
	{
		config: { id: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID },
		disableScriptLoad: process.env.NODE_ENV !== 'production', // only run on production
		appName: 'Doctor diary'
	},
	router // auto tracking page views
)

new Vue({
	render: (h) => h(App),
	router,
	store,
	vuetify
}).$mount('#app')
